import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnInit, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

declare const $: any;

@Component({
  selector: 'app-dropdown-provider',
  templateUrl: './dropdown-provider.component.html',
  styleUrls: ['./dropdown-provider.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownProviderComponent),
      multi: true
    }
  ]
})
export class DropdownProviderComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  @Input() providers: any = [];
  @Input() ajustWidth = false;
  selectedProvider: number;
  @ViewChild('dropdown') dropdown: ElementRef;

  constructor() {
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $(this.dropdown.nativeElement)
      .dropdown({
        clearable: true,
        onChange: (value, text) => {
          this.selectedProvider = Number(value);
          this.propagateChange(this.selectedProvider);
        }
      })
    ;
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
    if (!isDisabled) {
      this.selectedProvider = 0;
      $(this.dropdown.nativeElement).dropdown('clear');
      $(this.dropdown.nativeElement).addClass('disabled');
    } else {
      $(this.dropdown.nativeElement).removeClass('disabled');
    }
  }

  writeValue(obj: any): void {
    if (obj !== null && obj !== undefined) {
      this.selectedProvider = obj;
    }
  }

  propagateChange = (_: any) => {
  }

}



// WEBPACK FOOTER //
// ./src/app/utils/dropdown-provider/components/dropdown-provider/dropdown-provider.component.ts